<div class="modal-header">
    <h5 class="modal-title">Overlapped Greet Times</h5>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="text-center p-5">
    <div class="avatar-icon-wrapper rounded-circle m-0">
        <div
            class="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper bg-neutral-success text-success m-0 d-130">
            <fa-icon [icon]="['far', 'lightbulb']" class="d-flex align-self-center display-3"></fa-icon>
        </div>
    </div>
    <h4 class="font-weight-bold mt-4">
        <p class="mb-0 font-size-sm ">Already agent have a greet for that time</p>
        Are you sure you want to proceed?
    </h4>

    <div class="pt-4">
        <button (click)="closeModal()" class="btn btn-pill btn-neutral-secondary mx-1" type="button">
            <span class="btn-wrapper--label">
                NO
            </span>
        </button>
        <button (click)="cancelGreet()" class="btn btn-pill btn-success mx-1" type="button">
            <span class="btn-wrapper--label">
                YES
            </span>
        </button>
    </div>
</div>

<notifier-container></notifier-container>
<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>